import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { BulkValidationSummarySchema, makeValidatedRowSchema } from '../../shared/bulk-validation.schema';
import { InitializeAddOrgFunctionsRequestSchema, InitializeMembershipInputSchema, InitializeOrgFunctionInputSchema } from '../initialize-add-org-functions/initialize-add-org-functions.schema';
/**
 * Validated OrgFunction Row Schema
 * Echoes the input row plus resolved ids so the frontend renders resolution
 * results without re-deriving them.
 */ export const ValidatedOrgFunctionRowSchema = makeValidatedRowSchema(InitializeOrgFunctionInputSchema.extend({
    departmentId: z.string().optional(),
    leadId: z.string().optional(),
    /** Set when a same-name same-kind OrgFunction already exists (row will be skipped) */ existingOrgFunctionId: z.string().optional()
}));
export const ValidatedMembershipRowSchema = makeValidatedRowSchema(InitializeMembershipInputSchema.extend({
    memberId: z.string().optional()
}));
/**
 * Initialize Validate OrgFunctions Request Schema
 * POST /api/v2/initialize/org-functions/validate — dry-run twin of the
 * commit endpoint; same request shape, no writes.
 */ export const InitializeValidateOrgFunctionsRequestSchema = InitializeAddOrgFunctionsRequestSchema;
export const InitializeValidateOrgFunctionsResponseSchema = BulkValidationSummarySchema.extend({
    functions: z.array(ValidatedOrgFunctionRowSchema),
    teams: z.array(ValidatedOrgFunctionRowSchema),
    memberships: z.array(ValidatedMembershipRowSchema)
});
export const InitializeValidateOrgFunctionsErrorSchema = BaseErrorSchema;

//# sourceMappingURL=initialize-validate-org-functions.schema.js.map